import { BorderButton } from "src/components/buttons/BorderButton";
import { useForm } from "src/components/forms/Form";
import { InputItem } from "src/components/inputs/InputItem";
import { InputText } from "src/components/inputs/InputText";
import Modal, { ModalProps } from "src/components/modals/Modal";
import { SettingModel } from "src/models/SettingModel";
import UserModel from "src/models/UserModel";
import { modals, useModal } from "src/utils/modals";
import { emailRegex } from "src/utils/urlify";
import { SettingType } from "types/code-generator";

interface Props extends ModalProps {
  type: SettingType;
  onSubmit: (setting: SettingModel) => void;
  user: UserModel;
  setting: SettingModel;
}

export const AddContactModal = modals.create((props: Props) => {
  const form = useForm();
  const modal = useModal();

  let description = (
    <p>
      This email address will be copied anytime the primary account holder is
      emailed (excluding direct messages).
    </p>
  );

  if (props.type === SettingType.SecondaryContactPhone) {
    description = (
      <p>
        This phone number will be texted anytime the primary account holder is
        texted (excluding direct texts).
      </p>
    );
  }

  async function onSubmit() {
    form.validateFields((err, values) => {
      if (err) {
        console.log("err", err);
        return;
      }

      console.log("values", values);

      if (values.additionalContact) {
        if (props.type === SettingType.SecondaryContactEmail) {
          const valid = emailRegex.test(values.additionalContact);

          console.log("valid", valid);

          if (valid) {
            props.onSubmit({
              ...props.setting,
              type: SettingType.SecondaryContactEmail,
              value: values.additionalContact,
            });

            modal.hide();
          } else {
            form.setFields({
              additionalContact: {
                value: values.additionalContact,
                errors: [new Error("Please enter a valid email address")],
              },
            });
          }
        } else {
          props.onSubmit({
            ...props.setting,
            type: SettingType.SecondaryContactPhone,
            value: values.additionalContact,
          });

          modal.hide();
        }
      }
    });
  }

  const label =
    props.type === SettingType.SecondaryContactEmail ? "Email" : "Phone";

  return (
    <Modal
      visible={modal.visible}
      handleCancel={modal.hide}
      afterClose={modal.remove}
      title={`Additional ${label}`}
      footer={
        <>
          <BorderButton type="submit" onClick={onSubmit}>
            Save
          </BorderButton>
          <BorderButton onClick={modal.hide}>Cancel</BorderButton>
        </>
      }
    >
      <div>{description}</div>

      <InputItem
        form={form}
        name="additionalContact"
        initialValue={
          props.user.secondaryContacts.find((c) => c.id === props.setting?.id)
            ? props.user.secondaryContacts.find(
                (c) => c.id === props.setting?.id
              ).value
            : ""
        }
        rules={[
          {
            required: true,
            message: "Please enter a contact",
          },
        ]}
        label={`Additional Contact ${label}`}
      >
        <InputText
          type={
            props.type === SettingType.SecondaryContactEmail ? "email" : "tel"
          }
          placeholder={`Additional Contact ${label}`}
        />
      </InputItem>
    </Modal>
  );
});
